<ng-container>
    <div class="mx-5 my-4 product-details-container">
        <form [formGroup]="productSLDetailsForm" (ngSubmit)="onAddAction()">
            <div class="px-2">
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': productSLDetailsForm.get('productId')?.invalid && productSLDetailsForm.get('productId')?.touched}">Approved Products</label>
                        <select class="form-control form-control-lg form-control-solid"
                            [ngClass]="{'border-danger': productSLDetailsForm.get('productId')?.invalid && productSLDetailsForm.get('productId')?.touched}"
                            formControlName="productId" name="productId">
                            <option [value]="null">Select Approved Products</option>
                            <option [value]="product.productId" *ngFor="let product of this.approvedProductList()">
                                {{product.productName}}
                            </option>
                        </select>
                        @if (productSLDetailsForm.get('productId')?.invalid && productSLDetailsForm.get('productId')?.touched) {
                            <span class="text-danger">
                                @if (productSLDetailsForm.get('productId')?.errors?.['required']) {
                                    Approved Products is required.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': productSLDetailsForm.get('stateId')?.invalid && productSLDetailsForm.get('stateId')?.touched}">Approved States</label>
                        <mat-select [title]="getApprovedStateName(productSLDetailsForm.get('stateId')?.value ) || ''" class="form-control form-control-lg form-control-solid" formControlName="stateId" name="stateId" (openedChange)="onApprovedStateDropdownOpened($event)">
                            <mat-select-trigger>
                                {{getApprovedStateName(productSLDetailsForm.get('stateId')?.value) || ''}}
                            </mat-select-trigger>
                            <!-- Search input -->
                            <div class="search-container mb-2 mx-2">
                                <input
                                    placeholder="Search..."
                                    [value]="searchApprovedStatesList() ? searchApprovedStatesList() : ''"
                                    (input)="onApprovedStateSearch($event)"
                                    (keydown.space)="$event.stopPropagation()" 
                                    class="form-control form-control-lg form-control-solid"
                                />
                            </div>
                            <div class="option-container pt-4">
                                <!-- Options -->
                                <mat-option *ngFor="let state of filteredApprovedStatesList() || []" [value]="state.stateId">
                                    {{ state.stateName }}
                                </mat-option>
                                <!-- No results -->
                                <mat-option *ngIf="filteredApprovedStatesList().length === 0" disabled>
                                    No options found
                                </mat-option>
                            </div>
                        </mat-select>
                        @if (productSLDetailsForm.get('stateId')?.invalid && productSLDetailsForm.get('stateId')?.touched) {
                            <span class="text-danger">
                                @if (productSLDetailsForm.get('stateId')?.errors?.['required']) {
                                    Approved States is required.
                                }
                            </span>
                        }
                    </div>
                </div>        
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': productSLDetailsForm.get('personalLicenseHeld')?.invalid && productSLDetailsForm.get('personalLicenseHeld')?.touched}">Personal SL License held</label>
                        <div class="pt-8 ps-4">
                            <input type="radio" class="form-check-input me-2" id="yes" [value]="1" formControlName="personalLicenseHeld" name="personalLicenseHeld" />
                            <label class="form-check-label me-5" for="yes">Yes</label>
                            <input type="radio" class="form-check-input me-2" id="no" [value]="0" formControlName="personalLicenseHeld" name="personalLicenseHeld" />
                            <label class="form-check-label me-5" for="ssl">No</label>
                        </div>
                        @if (productSLDetailsForm.get('personalLicenseHeld')?.invalid && productSLDetailsForm.get('personalLicenseHeld')?.touched) {
                            <span class="text-danger">
                                @if (productSLDetailsForm.get('personalLicenseHeld')?.errors?.['required']) {
                                    Personal SL License held is required.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': productSLDetailsForm.get('slLicenseNumber')?.invalid && productSLDetailsForm.get('slLicenseNumber')?.touched}">State SL License #</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': productSLDetailsForm.get('slLicenseNumber')?.invalid && productSLDetailsForm.get('slLicenseNumber')?.touched}"
                            formControlName="slLicenseNumber" placeholder="" name="slLicenseNumber" maxlength="128"/>
                        @if (productSLDetailsForm.get('slLicenseNumber')?.invalid && productSLDetailsForm.get('slLicenseNumber')?.touched) {
                            <span class="text-danger">
                                @if (productSLDetailsForm.get('slLicenseNumber')?.errors?.['required']) {
                                    State SL License is required.
                                }@else if (productSLDetailsForm.get('slLicenseNumber')?.errors?.['pattern']) {
                                    State SL License must be alphanumeric.
                                }@else if (productSLDetailsForm.get('slLicenseNumber')?.errors?.['maxlength']) {
                                    State SL License must be no longer than 128 characters.
                                }
                            </span>
                        }
                    </div>
                </div>     
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating required"
                        [ngClass]="{'border-danger': productSLDetailsForm.get('slLicenseExpiryDate')?.invalid && productSLDetailsForm.get('slLicenseExpiryDate')?.touched}">State SL License Expiry Date</label>
                        <input class="form-control form-control-solid ps-6" type="date" 
                        [ngClass]="{'border-danger': productSLDetailsForm.get('slLicenseExpiryDate')?.invalid && productSLDetailsForm.get('slLicenseExpiryDate')?.touched}"
                        formControlName="slLicenseExpiryDate" name="slLicenseExpiryDate" />
                        @if (productSLDetailsForm.get('slLicenseExpiryDate')?.invalid && productSLDetailsForm.get('slLicenseExpiryDate')?.touched) {
                            <span class="text-danger">
                                @if (productSLDetailsForm.get('slLicenseExpiryDate')?.errors?.['required']) {
                                    State SL License Expiry Date is required.
                                }@else if (productSLDetailsForm.get('slLicenseExpiryDate')?.errors?.['pattern']) {
                                    Please enter a valid date.
                                }
                            </span>
                        }
                    </div>
                </div>    
                <div [attr.title]="this.productSLDetailsForm.invalid ? 'Please fix the errors in the form.' : null">
                    <button mat-button type="submit" [disabled]="this.productSLDetailsForm.invalid" class="btn btn-lg btn-primary continue-btn">Add</button>
                </div>
            </div>
        </form>
        <div class="mt-4 mx-2">
            <app-product-sl-details-list (removeApprovedProductEmitter)="removeProductSlDetail($event)" [productSlDetailsList]="productSlDetailsList()"></app-product-sl-details-list>
        </div>
    </div>
</ng-container>